import {
  BookingQuestionData,
  ExternalBookingQuestion,
} from "../../AppDataProvider/types";

import {
  BookingQuestionFieldType,
  BookingQuestionInput,
} from "../../GeneratedGraphQL";

type GetBookingQuestionInputOptions = {
  bookingQuestionData?: BookingQuestionData;
  bookingQuestions?: ExternalBookingQuestion[];
  pickedServiceId?: string;
};

export const getBookingQuestionInput = ({
  bookingQuestions = [],
  bookingQuestionData = {},
  pickedServiceId = undefined,
}: GetBookingQuestionInputOptions): BookingQuestionInput[] => {
  const bookingQuestionsPayload: BookingQuestionInput[] = [];

  const defaultLabel = "I agree to the terms and conditions";

  bookingQuestions.forEach(
    ({ id, name: label, type, url, subquestions, services }) => {
      const questionLabel =
        type === "TERMS" && url ? url : label || defaultLabel;

      const questionId = id ?? label;

      if (
        services &&
        !services.some((element) => element._id === pickedServiceId)
      ) {
        return;
      }

      /**
       * File type questions should not be included in the booking payload
       * at all if an S3 key isn't provided.
       */
      if (
        type === BookingQuestionFieldType.File &&
        !bookingQuestionData[questionId]
      ) {
        return;
      }

      bookingQuestionsPayload.push({
        label: questionLabel,
        type,
        ...(id && {
          id,
        }),
        ...(bookingQuestionData[questionId] && {
          value: bookingQuestionData[questionId].toString(),
        }),
      });

      if (subquestions && subquestions.length > 0) {
        subquestions.forEach(({ id, name: label, type, url }) => {
          const questionLabel =
            type === "TERMS" && url ? url : label || defaultLabel;
          /**
           * File type questions should not be included in the booking payload
           * at all if an S3 key isn't provided.
           */
          if (
            type === BookingQuestionFieldType.File &&
            !bookingQuestionData[id]
          ) {
            return;
          }
          bookingQuestionsPayload.push({
            label: questionLabel,
            type,
            ...(id && {
              id,
            }),
            ...(bookingQuestionData[id] && {
              value: bookingQuestionData[id].toString(),
            }),
          });
        });
      }
    },
  );

  return bookingQuestionsPayload;
};
